/* eslint-disable guard-for-in */

// MERGE TWO JS OBJECTS
export default function(obj1, obj2) {
  if (obj2) {
    for (const key in obj2) {
      obj1[key] = obj2[key];
    }
  }
}
/* eslint-enable */
